<template>
  <in-viewport>
    <div class="trust-section">
      <base-layout>
        <border-box slot="sidebar">
          <h2 v-html="heading"/>
        </border-box>
        <div slot="content">
          <grid-row>
            <div class="trust-section__col">
              <border-box>
                <ul class="trust-section__list">
                  <li
                    v-for="(item, i) in customers"
                    :key="i"
                    class="trust-section__item"
                  >
                    <a :href="item.link" v-if="item.link" target="_blank" class="trust-section__link">
                      {{ item.name }}
                    </a>
                    <span v-else class="trust-section__nolink">{{ item.name }}</span>
                  </li>
                </ul>
              </border-box>
            </div>
            <div class="trust-section__col">
              <border-box xs-hide>
                <ul class="trust-section__list">
                  <li
                    v-for="(item, i) in customers2"
                    :key="i"
                    class="trust-section__item"
                  >
                    <a :href="item.link" v-if="item.link" target="_blank" class="trust-section__link">
                      {{ item.name }}
                    </a>
                    <span v-else class="trust-section__nolink">{{ item.name }}</span>
                  </li>
                </ul>
              </border-box>
            </div>
          </grid-row>
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    customers: {
      type: Array,
      default: () => []
    },
    customers2: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .trust-section {
    @include vertical-space((bottom: 1));

    &__list {
      @include reset-list;
    }

    &__link {
      @include reset-link;
      @include text(big, bold);

      transition: color $base-transition;

      &:hover {
        @include theme-opposite(color);
      }
    }

    &__nolink {
     @include reset-link;
     @include text(big, bold);
     transition: color $base-transition;
    }

    &__col {
      @include grid-column((xs: 12, md: 6));

      @include media-up(lg) {
        &:first-child {
          @include nested-column-width(4, 9, lg);
        }

        &:last-child {
          @include nested-column-width(5, 9, lg);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/About/TrustSection.vue